import React from "react";
import {
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import useMediaQueryUtils from "../../utils/mediaQueryUtils";
export default function GemstoneCollections(props) {
  const isMdScreen = useMediaQueryUtils("md");

  const handleFilterClick = (value) => {
    if (value === "All Gemstones") {
      props.dispatch({
        type: "clearFilters",
        payload: [],
      });
    } else {
      props.clearFilters({
        name: "Collection",
        values: [{ name: value }],
      });
    }
  };

  const handleSelectChange = (e) => {
    handleFilterClick(e.target.value);
  };

  return (
    <>
      {isMdScreen ? (
        <FormControl fullWidth size="medium" sx={{ my: 1 }}>
          <InputLabel id="gemstone-collection-label">Collection</InputLabel>
          <Select
            labelId="gemstone-collection-label"
            value={props.valueForColor || ""}
            label="Collection"
            onChange={handleSelectChange}
          >
            {props.collection.map(({ name }) => (
              <MenuItem value={name} key={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <Grid container>
          <Grid item className="gemstone-filter" sx={{ width: "100%" }}>
            {props.collection.map(({ name }) => (
              <Button
                className="gemstone-category"
                key={name}
                disableElevation
                variant="contained"
                color={props.valueForColor === name ? "primary" : "secondary"}
                onClick={() => handleFilterClick(name)}
              >
                {name}
              </Button>
            ))}
          </Grid>
        </Grid>
      )}
    </>
  );
}
